import { Link } from 'react-router-dom';
import Terms from '../terms/terms';
import { useT } from '../i18n/i18n';

/**
 * PUBLIC ON PURPOSE. Somebody deciding whether to sign up has not signed in, and terms you
 * have to have an account to read are no use to the person choosing whether to get one.
 */
export default function TermsPage() {
  const t = useT();
  return (
    <section aria-labelledby="terms-h" style={{ maxWidth: 760, margin: '0 auto' }}>
      <div className="card">
        <h2 id="terms-h">{t('Terms and what this is')}</h2>
        <Terms />
        <div className="toolbar">
          <Link className="btn secondary" to="/">{t('Back')}</Link>
          <Link className="btn ghost" to="/privacy">{t('Privacy')}</Link>
        </div>
      </div>
    </section>
  );
}
